import { render, staticRenderFns } from "./TestTutorialsPartFour.vue?vue&type=template&id=21533e9a&scoped=true&"
import script from "./TestTutorialsPartFour.vue?vue&type=script&lang=js&"
export * from "./TestTutorialsPartFour.vue?vue&type=script&lang=js&"
import style0 from "./TestTutorialsPartFour.vue?vue&type=style&index=0&id=21533e9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21533e9a",
  null
  
)

export default component.exports